<div style="margin-left: 2vw; margin-top:2%; text-align:left;">
    <span style="text-align: center; width:85%">
        <br />
        uuid: <b> {{ uuid }}</b><br />
        Dispositivo: <b> {{ nombreDisp }} </b><br />
    </span>
</div>


<div style="margin-top:2%; text-align:left;"> <!-- align="left" -->
    <a style="margin-left: 2vw; cursor: pointer;" (click)="previousState()">
        <i class="material-icons">chevron_left</i>
    </a>
    <span style = "margin-left: 35%;">
        <b>Informacion sobre los datos del dispositivo:</b> {{ nombre }} 
    </span>
</div>



<br/>



<mat-form-field class="filtro-tabla">
    <mat-label>Filtrar</mat-label>
    <input matInput (keyup)="applyFilterDato($event)" placeholder="Filtrar datos...">
</mat-form-field>

<div class="spinner-loading" align="center" [hidden]="!loadingDatos" >
    <mat-progress-spinner mode="indeterminate"  strokeWidth="3" value="7" diameter="75" style="margin:0 auto;"></mat-progress-spinner>
</div>

<div class="mat-elevation-z8" style="width:85%;" align="center" [hidden]="loadingDatos">
  <table mat-table [dataSource]="dataSourceDato"> 
    
    <ng-container matColumnDef="uuidDato">
        <th mat-header-cell *matHeaderCellDef> <b>uuid del dato</b> </th>
        <td mat-cell *matCellDef="let d" matTooltip={{d.descripcion}}  > 
            <span ngxClipboard [cbContent]="d.uuid"  (cbOnSuccess)="copiado($event)">
                <span *ngIf="!d.calcula?.disabled"> {{d.uuid}} </span>
                <span *ngIf="d.calcula?.disabled">
                    <i class="material-icons warning" title="Dato deshabilitado . Navega para identificar el problema.">
                        warning
                    </i>
                    {{d.uuid}}
                </span>
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="uuidMedicion">
      <th mat-header-cell *matHeaderCellDef> <b>uuid medición </b></th>
      <td mat-cell *matCellDef="let d" ngxClipboard [cbContent]="d.es.uuid"  (cbOnSuccess)="copiado($event)"> {{d.es.uuid}} </td>
    </ng-container>

  
    <ng-container matColumnDef="nombreMedicion">
      <th mat-header-cell *matHeaderCellDef> <b>Nombre de la medicion</b> </th>
      <td mat-cell *matCellDef="let d" ngxClipboard [cbContent]="d.es.uuid"  (cbOnSuccess)="copiado($event)"> {{d.es.nombre}} </td>
    </ng-container>


    <ng-container matColumnDef="cantidadDatos">
      <th mat-header-cell *matHeaderCellDef> <b>Cantidad de datos</b> </th>
      <td mat-cell *matCellDef="let d"> {{d.stats_count}} </td>
    </ng-container>

    <ng-container matColumnDef="unidadMedicion">
      <th mat-header-cell *matHeaderCellDef> <b> Unidad de la medición </b></th>
      <td mat-cell *matCellDef="let d"> {{d.es.unidad}} </td>
    </ng-container>

    <ng-container matColumnDef="botones">
      <th mat-header-cell *matHeaderCellDef> <b>Acción</b> </th>
      <td mat-cell *matCellDef="let d" align="center"> 
        <div class="btn-group" style="text-align: center; margin:auto; display:block">
            <a style=" padding-left: 15px"
                title="Navegar al dato {{d.es.nombre}}" [routerLink] = "['/dato', d.uuid]">
                <i class="material-icons" style="color: #303F9F;cursor: pointer;">
                    forward
                </i>
            </a>
            <a style=" padding-left: 15px" title= "Editar el dato {{ d.es.nombre}}">
                <i class="material-icons" style="color: rgb(80, 194, 90);cursor: pointer;">
                    edit
                </i>
            </a>
            <a style="padding-top:-5px; padding-left: 0.7vw;" title = "Eliminar el dato {{ d.es.nombre}}">
                <i class="material-icons" style="color: rgb(168, 26, 26);cursor: pointer;">
                    delete
                </i>
            </a>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'trWarning': row.calcula?.disabled}" ></tr> 
  </table>
  <mat-paginator #TableDatosPaginator="matPaginator" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons [hidden]="loadingDatos"></mat-paginator>
</div>





<div style="padding-top:5vh;">
    <hr style="margin-left:2vw; width: 85%;">
</div>



<!-- TABLA QUE MUESTRA LOS DISPOSITIVOS QUE CUELGAN DEL DISPOSITIVO ACTUAL -->
<div style="padding-top:3vw; text-align: left;">
    <a style="margin-left: 2vw; cursor: pointer;" (click)="previousState()">
        <i class="material-icons">chevron_left</i>
    </a>
    <span style="margin-left: 35%;">
        <b>Dispositivos que cuelgan de:</b> {{ nombre }}
    </span>

</div>


<!-- 
<table style="margin-left: 2vw; margin-top: 1vh; width:85%" >
    <tr style="background-color:#303F9F;">
        <th style="text-align: center; width: 30%;"><b>Nombre</b></th>
        <th style="text-align: center; width: 15%;"><b>Descripción</b></th>
        <th style="text-align: center; width: 30%;"><b>uuid</b></th>
        <th style="text-align: center; width: 25%;"> Acción </th>
    </tr>
    <tr *ngFor="let dispositivo of dispositivos | paginate: {id:'paginacionDependen', itemsPerPage: 10, currentPage: p2 }">
        <td style="text-align: center;"> {{ dispositivo.Dispositivo.nombre }} </td>
        <td style="text-align: center;"> {{ dispositivo.Dispositivo.descripcion }} </td> 
        <td style="text-align: center;" name="uuidDispositivoDepende"> {{ dispositivo.Dispositivo.uuid }} </td> 
        <td style="width:5vw;">
            <div class="btn-group" style="text-align: center; margin:auto; display:block">
                    <a [routerLink]="['/disp', dispositivo.Dispositivo.uuid]" style=" padding-left: 15px" 
                    title = "Navegar al dispositivo {{ dispositivo.Dispositivo.nombre }}"> 
                        <i class="material-icons" style="color: #303F9F;cursor: pointer;">
                            forward
                        </i> 
                    </a>
                    <a (click)="[open(content), saveData(dispositivo)]" style="padding-top:-5px; padding-left: 0.7vw;"
                    title = "Editar los datos del dispositivo {{ dispositivo.Dispositivo.nombre }}"> 
                        <i class="material-icons" style="outline:hidden ;color: #303F9F;cursor: pointer;">
                            info
                        </i> 
                    </a> 
                    <a (click)="deleteEstructura(dispositivo)" style="padding-top:-5px; padding-left: 0.7vw;"
                    title = "Eliminar el dispositivo '{{ dispositivo.Dispositivo.nombre }}' de la estructura de {{nombre}}">
                        <i class="material-icons" style="outline:hidden ;color: rgb(168, 26, 26);cursor: pointer;">
                            delete
                        </i>
                    </a>
            </div>
    </tr>
</table>

<div align="center" style="width:85%; padding-top: 8px">
    <pagination-controls (pageChange)="p2 = $event" id="paginacionDependen" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
  </div>
 -->




<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input matInput (keyup)="applyFilterTo($event)" placeholder="Filtrar dispositivos...">
</mat-form-field>

<div class="spinner-loading" align="center"  [hidden]="!loadingDatos" >
    <mat-progress-spinner mode="indeterminate"  strokeWidth="3" value="7" diameter="75" style="margin:0 auto;"></mat-progress-spinner>
</div>


<div class="mat-elevation-z8" style="width:85%;" align="center" [hidden]="loadingDatos" >
  <table mat-table [dataSource]="dataSourceTo"> 
    
    <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef> <b>Nombre</b> </th>
        <td mat-cell *matCellDef="let d; index as i;"> 
                {{d.nombre}}
        </td>
    </ng-container>

    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef> <b> Descripción </b></th>
      <td mat-cell *matCellDef="let d"> {{d.descripcion}} </td>
    </ng-container>

  
    <ng-container matColumnDef="uuidDispositivo">
      <th mat-header-cell *matHeaderCellDef> <b>uuid del dispositivo</b> </th>
      <td mat-cell *matCellDef="let d; index as i"> 
        <span ngxClipboard [cbContent]="d.uuid"  (cbOnSuccess)="copiado($event)">
            {{d.uuid}}     
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="botones">
      <th mat-header-cell *matHeaderCellDef> <b>Acción</b> </th>
      <td mat-cell *matCellDef="let d" align="center"> 
        <div class="btn-group" style="text-align: center; margin:auto; display:block">
            <a style=" padding-left: 15px"
                title="Navegar al dispositivo {{d.nombre}}" [routerLink] = "['/disp', d.uuid]">
                <i class="material-icons" style="color: #303F9F;cursor: pointer;">
                    forward
                </i>
            </a>
            <a (click)="[saveData(d), open(content)]" style=" padding-left: 15px" title= "Editar el dispositivo {{ d.nombre }}">
                <i class="material-icons" style="color: rgb(80, 194, 90);cursor: pointer;">
                    edit
                </i>
            </a>
            <a (click)="deleteEstructura(d)" style="padding-top:-5px; padding-left: 0.7vw;" title = "Eliminar el dispositivo {{ d.nombre }}">
                <i class="material-icons" style="color: rgb(168, 26, 26);cursor: pointer;">
                    delete
                </i>
            </a>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsTo"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsTo;"></tr> 
  </table>
  <mat-paginator #TableToPaginator="matPaginator"   [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons [hidden]="loadingDatos"></mat-paginator> 
</div>


<!-- Boton para añadir un nuevo registro -->
<div align="center" style="margin-left: 2vw; width: 85%; padding-top: 15px" [hidden]="loadingDatos">
    <!-- <button mat-fab class="add-dependencia" (click)="open(contentAddDispDependen)"  title="Añadir un nuevo dispositivo que cuelgue de {{nombre}}">
        <h4>+</h4>
    </button> -->
    <button mat-fab class="add-dependencia" (click)="navegacionDependenciasTo()"  title="Añadir un nuevo dispositivo que cuelgue de {{nombre}}">
        <h4>+</h4>
    </button>
</div>



<div style="padding-top:5vh;">
    <hr style="margin-left:2vw; width: 85%;">
</div>



<!-- TABLA DE LOS DISPOSITIVOS DE LOS QUE CUELGA EL DISPOSITIVO ACTUAL -->
<div style="padding-top:3vw; text-align:left;">
    <a style="margin-left: 2vw; cursor: pointer;" (click)="previousState()">
        <i class="material-icons">chevron_left</i>
    </a>
    <span style="margin-left: 35%;">
        <b>Dispositivos de los que cuelga:</b> {{ nombre }}
    </span>
</div>







<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input matInput (keyup)="applyFilterFrom($event)" placeholder="Filtrar dispositivos...">
</mat-form-field>

<div class="spinner-loading"  align="center"  [hidden]="!loadingDatos" >
    <mat-progress-spinner mode="indeterminate"  strokeWidth="3" value="7" diameter="75" style="margin:0 auto;"></mat-progress-spinner>
</div>

<div class="mat-elevation-z8" style="width:85%;" align="center" [hidden]="loadingDatos">
  <table mat-table [dataSource]="dataSourceFrom"> 
    
    <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef> <b>Nombre</b> </th>
        <td mat-cell *matCellDef="let d; index as i;"> 
                {{d.nombre}}
        </td>
    </ng-container>

    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef> <b> Descripción </b></th>
      <td mat-cell *matCellDef="let d"> {{d.descripcion}} </td>
    </ng-container>

  
    <ng-container matColumnDef="uuidDispositivo">
      <th mat-header-cell *matHeaderCellDef> <b>uuid del dispositivo</b> </th>
      <td mat-cell *matCellDef="let d; index as i"> 
        <span ngxClipboard [cbContent]="d.uuid"  (cbOnSuccess)="copiado($event)">
           {{d.uuid}}     
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="botones">
      <th mat-header-cell *matHeaderCellDef> <b>Acción</b> </th>
      <td mat-cell *matCellDef="let d" align="center"> 
        <div class="btn-group" style="text-align: center; margin:auto; display:block">
            <a style=" padding-left: 15px"
                title="Navegar al dispositivo {{d.nombre}}" [routerLink] = "['/disp', d.uuid]">
                <i class="material-icons" style="color: #303F9F;cursor: pointer;">
                    forward
                </i>
            </a>
            <a (click)="[saveData(d), open(content)]" style=" padding-left: 15px" title= "Editar el dato {{ d.nombre }}">
                <i class="material-icons" style="color: rgb(80, 194, 90);cursor: pointer;">
                    edit
                </i>
            </a>
            <a (click)="deleteEstructuraDependeDe(d)" style="padding-top:-5px; padding-left: 0.7vw;" title = "Eliminar el dato {{ d.nombre }}">
                <i class="material-icons" style="color: rgb(168, 26, 26);cursor: pointer;">
                    delete
                </i>
            </a>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsFrom"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsFrom;"></tr> 
  </table>
  <mat-paginator #TableFromPaginator="matPaginator" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons [hidden]="loadingDatos"></mat-paginator> 
</div>



<!-- Boton para añadir un nuevo registro -->
<div align="center" style="margin-left: 2vw; width: 85%; padding-top: 15px" [hidden]="loadingDatos">
    <!-- <button mat-fab class="add-dependencia" (click)="open(contentAddDispDependenDe)"  title="Añadir un nuevo dispositivo del que cuelgue {{nombre}}">
        <h4>+</h4>
    </button> -->
    <button mat-fab class="add-dependencia" (click)="navegacionDependenciasFrom()"  title="Añadir un nuevo dispositivo del que cuelgue {{nombre}}">
        <h4>+</h4>
    </button>
</div>


<div style="margin-bottom: 5px;"></div>


<!-- Modal bootstrap para cuando se pulse el boton de ver los datos -->
<!-- <ng-template #content1 let-modal> -->

<!-- <div class="modal-content" #content> -->
<ng-template #content let-modal>
    <div class="modal-header" >
        <h4 class="modal-title" id="modal-basic-title">Actualizar datos para el dispositivo <b>{{tituloModal}}</b> </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <label for="uuid"><b>UUID</b></label>
                <div class="input-group">
                    <input type="text" [(ngModel)]="uuidModal" class="form-control" name="uuidModal" id="uuidModal" disabled>
                </div>
                <label for="nombre"><b>Nombre</b></label>
                <div class="input-group">
                    <input type="text" id="nombreModal" class="form-control" name="nombreModal"  autocomplete="off"
                    [(ngModel)]="nombreModal" > <!--(ngModelChange)="descripcionChange($event)"-->
                    <!-- [value]="nombreModal" -->
                </div>
                <label for="descripcion"><b>Descripcion</b></label>
                <div class="input-group">
                    <input type="text" id="descripcionModal"  autocomplete="off" class="form-control" name="descripcionModal" 
                    [(ngModel)]="descripcionModal">
                </div>
                <label for="descripcion"><b>Nombre Tecnico</b></label>
                <div class="input-group">
                    <input type="text" id="nombreTecnicoModal"  autocomplete="off" class="form-control" name="nombreTecnicoModal" 
                    [(ngModel)]="nombreTecnicoModal">
                </div>        
                
                
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" id="boton-cerrar-modal" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
        <button type="button" id="boton-enviar-datos-modal" class="btn btn-outline-dark" [disabled]="!nombreModal" (click)="[actualizarDatos(), modal.close('Save click')]">Actualizar datos</button>
    </div>
</ng-template> 




<!-- TABLA PARA AÑADIR DISPOSITIVOS -->
<ng-template #contentAddDispDependen let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Añadir dispositivo a <b>{{nombre}}</b> </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <label for="uuid"><b>uuid de {{ nombre }} </b></label>
                <div class="input-group">
                    <input type="text" [(ngModel)]="uuid" style="cursor:no-drop" class="form-control" name="uuid" disabled>
                </div>
                <label for="nombre"><b>uuid del nuevo dispositivo</b></label>
                <div class="input-group">
                    <input type="text" id="uuidAddDisp" class="form-control" name="uuidAddDisp" id="uuidAddDisp" autocomplete="off"
                        [(ngModel)]="uuidAddDisp">
                    <!--(ngModelChange)="descripcionChange($event)"-->
                    <!-- [value]="nombreModal" -->
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" id="boton-cerrar-modal" class="btn btn-secondary"
            (click)="modal.dismiss()">Cerrar</button>
        <button type="button" id="boton-crear-dispositivo" class="btn btn-outline-dark" [disabled]="!uuidAddDisp" 
            (click)="[mergeEstructuraDependen(), modal.close('Save click')]">Crear estructura</button>
    </div>
</ng-template>

<!-- TABLA PARA AÑADIR DISPOSITIVOS -->
<ng-template #contentAddDispDependenDe let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Añadir dispositivo a <b>{{nombre}}</b> </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <label for="uuid"><b>uuid de {{ nombre }} </b></label>
                <div class="input-group">
                    <input type="text" [(ngModel)]="uuid" style="cursor:no-drop" class="form-control" name="uuid" disabled>
                </div>
                <label for="nombre"><b>uuid del nuevo dispositivo</b></label>
                <div class="input-group">
                    <input type="text" id="uuidAddDisp" class="form-control" name="uuidAddDisp" id="uuidAddDisp" autocomplete="off"
                        [(ngModel)]="uuidAddDisp">
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" id="boton-cerrar-modal" class="btn btn-secondary"
            (click)="modal.dismiss()">Cerrar</button>
        <button type="button" id="boton-crear-dispositivo" class="btn btn-outline-dark" [disabled]="!uuidAddDisp"
            (click)="[mergeEstructuraDependeDe(), modal.close('Save click')]">Crear estructura</button>
    </div>
</ng-template>







<!--  -->